import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/messenger.vue
var s = {
	name: "DtIconMessenger",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["fill"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--messenger"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Messenger",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M12 2.86c-5.281 0-9.375 3.868-9.375 9.093 0 2.733 1.12 5.095 2.944 6.726a.75.75 0 0 1 .252.535l.051 1.668a.75.75 0 0 0 1.053.663l1.86-.822a.748.748 0 0 1 .501-.037c.855.236 1.765.36 2.714.36 5.281 0 9.375-3.868 9.375-9.093S17.281 2.86 12 2.86Z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, l),
		t[1] || (t[1] = i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "m6.37 14.613 2.754-4.37a1.406 1.406 0 0 1 2.034-.375l2.19 1.643c.2.15.477.15.678-.002l2.958-2.245c.394-.3.91.173.646.592l-2.754 4.37a1.406 1.406 0 0 1-2.034.374l-2.19-1.642a.562.562 0 0 0-.678.002l-2.958 2.245c-.395.3-.91-.173-.646-.592Z",
			fill: "#fff"
		}, null, -1)),
		i("defs", null, [i("radialGradient", {
			id: `${e.uniqueID}a`,
			cx: "0",
			cy: "0",
			r: "1",
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(6.234 21.51) scale(20.4299)"
		}, [...t[0] || (t[0] = [
			i("stop", { "stop-color": "#09F" }, null, -1),
			i("stop", {
				offset: ".61",
				"stop-color": "#A033FF"
			}, null, -1),
			i("stop", {
				offset: ".935",
				"stop-color": "#FF5280"
			}, null, -1),
			i("stop", {
				offset: "1",
				"stop-color": "#FF7061"
			}, null, -1)
		])], 8, u)])
	], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=messenger.js.map